import { render, staticRenderFns } from "./pay-mask.vue?vue&type=template&id=5ebfaab3&scoped=true&"
import script from "./pay-mask.vue?vue&type=script&lang=js&"
export * from "./pay-mask.vue?vue&type=script&lang=js&"
import style0 from "./pay-mask.vue?vue&type=style&index=0&id=5ebfaab3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebfaab3",
  null
  
)

export default component.exports